var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M36.75 29.0917V12.9082C36.75 12.6753 36.688 12.4466 36.5705 12.2456C36.4529 12.0446 36.2839 11.8784 36.081 11.7643L21.6435 3.64317C21.447 3.53266 21.2254 3.47461 21 3.47461C20.7746 3.47461 20.553 3.53266 20.3565 3.64317L5.91903 11.7643C5.71605 11.8784 5.54711 12.0446 5.42954 12.2456C5.31197 12.4466 5.25 12.6753 5.25 12.9082V29.0917C5.25 29.3246 5.31197 29.5533 5.42954 29.7543C5.54711 29.9554 5.71605 30.1215 5.91903 30.2357L20.3565 38.3568C20.553 38.4673 20.7746 38.5253 21 38.5253C21.2254 38.5253 21.447 38.4673 21.6435 38.3568L36.081 30.2357C36.2839 30.1215 36.4529 29.9554 36.5705 29.7543C36.688 29.5533 36.75 29.3246 36.75 29.0917Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M29.0427 25.0213V16.4901L13.125 7.71094",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M36.5689 12.2433L21.1556 20.9998L5.43164 12.2417",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M21.1555 21L21.0015 38.5254",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.80128d6fd71d500d45453e1e64a23d34.svg";
export { ForwardRef as ReactComponent };